import moment from 'moment';
import React, { ChangeEvent, useContext, useState, useEffect } from 'react';
import Avatar from 'react-avatar';
import { BankUserContext } from '../../../bankUserContext';
import CommentMentions from '../../../commonfields/CommentMentions';
import { ICaseCommentModel } from '../../../models/Cases/CaseDetailsModel';
import { formatTimestamp } from '../../../utils/GeneralUtils';

interface ICaseCommentInnerFC {
  comment: ICaseCommentModel,
  deleteComment: (commentId: string) => void;
  updateComment: (commentId: string, comment: string) => void;
  data: any;
  onAdd: (id: string) => void; 
  setSuggestedUsers: (value: string[] | []) => void;
}

const CaseCommentInnerFC = (props: ICaseCommentInnerFC) => {
  const { comment, data, onAdd, deleteComment, setSuggestedUsers } = props;
  const bankUserContext = useContext(BankUserContext);
  const [ showEditMode, setShowEditMode] = useState(false);
  const [ editingCommentValue, setEditingCommentValue] = useState(comment.comment);

  const editComment = () => {
    setShowEditMode(true);
    setSuggestedUsers(comment?.userId || []);
  }

  const onCommentChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setEditingCommentValue(e.target.value);
  }

  const updateComment = () => {
    if (editingCommentValue.trim() !== "") {
      props.updateComment(comment.caseCommentId, editingCommentValue);
      setShowEditMode(false);
    }
  }
  const cancelEditComment = () => {
    setShowEditMode(false);
    setEditingCommentValue(comment.comment);
  }
  

  return (
    <li className="commentslistContainer">
      <div className="commentssectionimagecontainer">
        <Avatar size="32px" round name={comment?.name} />
      </div>
      <div className="commentslisttextContainer">
        <div className="commentSectionNameandTimeContainer">
          <p className="commentsectionnametext">
            {comment.name}
          </p>
          <p className="createddateTime">
            { comment?.updatedDate ? 
                formatTimestamp(comment?.updatedDate) : 
                formatTimestamp(comment?.createdDate)
            }
          </p>
        </div>
        <CommentMentions
          placeholder="Add a Comment"  
          value={editingCommentValue} 
          handleChange={onCommentChange}
          data={data}
          onAdd={onAdd}
          disabled={!showEditMode}
          className={showEditMode ? 'edit' : 'disabled'}
        />
        {
          comment.createdBy === bankUserContext.bankuserDetails?.userId ?
          showEditMode ? 
            <div className="editformcontainer">
              <button type="button" onClick={() => updateComment()}>Save</button>
              <button type="button" onClick={() => cancelEditComment()}>Cancel</button>
            </div> : 
            <div className="deleteandeditconatiner">
              <p className="Commentsupdation" onClick={editComment}>
                Edit
              </p>
              <p className="Commentsupdation"> | </p>
              <p className="Commentsupdation" onClick={() => deleteComment(comment.caseCommentId)}>
                Delete
              </p>
            </div>
          : <></>
        }
      </div>
    </li>
  );
};

export default CaseCommentInnerFC;
